<template>
    <div>
        <el-card class="box-card" shadow="never" style="border:0;">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <div slot="header" style="border-bottom:0;">
                <span style="font-size:20px;">用户管理</span>
            </div>
            <!--<el-breadcrumb-item>用户管理</el-breadcrumb-item>-->

            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left" >
                <el-form :inline="true" :model="topForm" ref="topForm">

                    <el-form-item prop="name">
                        <el-input v-model="topForm.name" placeholder="用户姓名" ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary"  @click="getData" icon="search":loading="loading" >查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary"  @click="add()"    v-if="btnAll.btn_0412 " >新增</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="resetForm('topForm')" >重置</el-button>
                    </el-form-item>

                </el-form>
            </el-col>
            <!-- 弹窗新增标签-->
            <!--<el-button type="text" >打开嵌套表单的 Dialog</el-button>-->

            <el-dialog title="用户" :visible.sync="dialogFormVisible" :modal-append-to-body="false"
                       @close="dialodclose('userForm')">
                <el-form  :model="userForm" :rules="userrules" ref="userForm"  >

                    <el-form-item v-if="isable==false" label="用户名" prop="username">
                        <el-input  v-model="userForm.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>

                    <el-form-item v-if="isable==true" label="用户名">
                        <el-input  v-model="userForm.username" :disabled="isable"></el-input>
                    </el-form-item>


                    <el-form-item label="密码" prop="password">
                        <el-input  type="password" v-model="userForm.password" placeholder="请输入密码"></el-input>
                    </el-form-item>



                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false" >取 消</el-button>
                    <el-button type="primary" @click="submitForm('userForm')">保存</el-button>
                    <!--<el-button type="primary" @click="dialogFormVisible = false">保存</el-button>-->
                </div>
            </el-dialog>


            <!-- 表格分页-->
            <div class="block">
                <el-table :data="tableData" border style="width: 100%;" >
                    <el-table-column prop="user_id" label="id">  </el-table-column>
                    <el-table-column prop="username" label="用户名" > </el-table-column>
                    <el-table-column prop="name" label="当前权限" > </el-table-column>
                    <el-table-column prop="update_time" label="更新时间"  :formatter="formatter"  sortable >  </el-table-column>
                    <el-table-column label="操作" width="350" >
                        <template scope="scope" >
                            <el-button  size="small" @click="userEdit(scope.row)"    v-if="  btnAll.btn_0414  && scope.row.username!='admin'">编辑</el-button> <!--   v-bind:class="{ clearBtn: btnAll.btn_0414 }-->
                            <el-button  size="small" type="danger"  @click="handleDelete(scope.row)"   v-if="btnAll.btn_0415  && scope.row.username!='admin' "  >删除</el-button>
                            <el-button  size="small" type="info" @click="addRoles(scope.row)" v-if="btnAll.btn_0416  && scope.row.username!='admin'" >绑定角色</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="block">
                <el-pagination
                        @current-change="handleCurrentChange"
                        @size-chahange="handleSizeChange"
                        :current-page="currentpage"
                        :page-count="pagesCount"
                        :page-sizes="pagesizes"
                        :page-size="pagesize"
                        :total="pagesCount"
                        background
                        layout=" total, prev, pager, next, jumper"
                >
                </el-pagination>
            </div>
        </el-card>
        <!-- 操作-->


    </div>
</template>

<script>
    import action from "../../../store/actions"
    import moment  from 'moment'
    export  default{
        data(){
            var validateName = (rule, value, callback) => {
                if(this.isable == false) {
                    if (value === '') {
                        callback(new Error('请输入用户名！'));
                    } else {
                        this.$http.get(this.requetHost+"/sys/user/validate",{params:{"username":value}}).then(response => {
                            if (response.status === 200) {
                                if (response.body.status === "200"){
                                    callback(new Error('用户名已存在请重新输入！'));
                                }else{
                                    callback();
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                    }
                }else{
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码！'));
                }else {
                    if(value.length<6){
                        callback(new Error('密码不能小于六位！'));
                    }
                    if (this.userForm.password.indexOf(" ") == -1) {
                        callback();
                    }else {
                        callback(new Error('密码不能包含空格！'));
                    }
                    callback();
                }
            };
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                //参数设置
                url: this.requetHost+"/sys/user/findUsers", // 分页查询请求路径
                name: '',
                loading:false,
                isable:false,
                dialogVisible: false,
                /*弹窗选择*/
                dialogFormVisible: false,
                /*弹窗内容选择*/
                topForm:{
                    name:''
                },
                userForm:{
                    username:'',
                    password:'',
                    tenantId:'00001',
                    id:''
                },
                tenantList:[],
                userrules: {
                    username: [
                        {required: true,message: '请输入用户名称', trigger: 'blur'},
                        { validator: this.validatorSpace, trigger: 'blur' },
                        { validator: this.validatorCharmap, trigger: 'blur' },
                        { min: 1, max: 12, message: '长度在 1 到 12 个字符', trigger: 'blur' },
                        { validator: validateName, trigger: 'blur' },

                    ],
                    tenantId:[
                        {required: true, message: '请选择托管用户', trigger: 'change'}

                    ],
                    password: [
                        {required: true,message: '请输入密码', trigger: 'blur'},
                        { validator: this.validatorSpace, trigger: 'blur' },
                        /*{ validator: this.validatorCharmap, trigger: 'blur' },*/
                        { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' },
                        { validator: validatePass, trigger: 'blur' },

                    ]
                },
//                btn_0412:this.$store.state.btn_0412,
//                btn_0413:this.$store.state.btn_0413,
//                btn_0414:this.$store.state.btn_0414,
//                btn_0415:this.$store.state.btn_0415,
//                btn_0416:this.$store.state.btn_0416,
//                btn_0417:this.$store.state.btn_0417
                btnAll:{
                    btn_0412:true,
                    btn_0414:true,
                    btn_0415:true,
                    btn_0416:true,
                    btn_0417:true
                },
//                btnAll:{
//                    btn_0412:this.$store.state.btn_0412,
//                    btn_0414:this.$store.state.btn_0414,
//                    btn_0415:this.$store.state.btn_0415,
//                    btn_0416:this.$store.state.btn_0416,
//                    btn_0417:this.$store.state.btn_0417
//                },

            }

        },
        created(){

            this.getData();
            /*if(this.getcookie("tenant_id")!="000000"){
               this.updateBtnState("041");
          }*/

            //this.btn_0412=true;

        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            getData(){
                //数据请求
                this.loading = true
                var params = {active:this.activeNum,len:this.pagesize,username:this.topForm.name,storeId:this.getcookie('storeId')};
                //异步请求
                this.$http.post(this.url,params)
                    .then(response => {
                        if (response.status === 200) {
                            this.pagesCount = response.body.total
                            this.tableData = response.body.data
                            this.loading = false;
                            //this.getBtn();
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            formatter(row, column) {
                var d = new Date(row.update_time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            handleDelete(row) {
                if(row.username =="admin"){
                    this.$message({showClose: true,message: '系统用户不能删除！',type: 'warning'});
                }else{
                    if(row.username == this.getcookie('username')) {
                        this.$message({showClose: true,message: '对不起！您不能删除自己！',type: 'warning'});
                    }else {
                        debugger;
                        this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            // this.$store.dispatch('delUser',row.id).then((data)=>{
                            var params={id:row.id,userId:row.user_id};
                            this.$store.dispatch('delUser',params).then((data)=>{
                                if(data.status=="200"){
                                    this.$message({showClose: true,message: '删除成功',type: 'success'});
                                    this.getData();
                                }else{
                                    this.$message({showClose: true,message: '不可删除',type: 'error'});
                                }
                            })
                        })
                    }
                }
            },
            add(){
                this.userForm.id="";
                this.userForm.password="";
                this.userForm.username="";
              //  this.userForm.tenantId="";
                this.dialogFormVisible=true;
                this.isable = false;
          //    this. getTenantListWithFlag();
            },
            getTenantList(){
                this.$store.dispatch("getTenantList").then((res) => {
                    this.tenantList = res.tenants;
                }, () => {
                    this.$message({showClose: true, message: '网络异常', type: 'error'});
                })
            },
            getTenantListWithFlag(){
                this.$store.dispatch("getTenantListWithFlag").then((res) => {
                    this.tenantList = res.tenants;
                }, () => {
                    this.$message({showClose: true, message: '网络异常', type: 'error'});
                })
            },
            userEdit(row){
                this.isable = true;
                this.dialogFormVisible=true;
                this.getTenantListWithFlag();
                this.userForm.username=row.username;
                //this.userForm.password=row.name;
                this.userForm.tenantId=row.tenant_id;

                this.userForm.id=row.id;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var params={username:this.userForm.username,password:this.userForm.password,tenantId:this.userForm.tenantId,storeId:this.getcookie('storeId')};
                        if(this.id!=""&&this.isable == true){
                            params.id=this.userForm.id;
                        }
                        this.$store.dispatch('editUser',params).then((data)=>{
                            if(data.status=="200"){
                                this.$message({showClose: true,message: '保存成功',type: 'success'});
                                this.getData();
                            }else{
                                this.$message({showClose: true,message: '参数错误',type: 'error'});
                            }
                            this.dialogFormVisible=false;
                        })


                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.getData();
            },
            addRoles(row){
                this.savecookie("button", "configRoles");
                this.$router.push( {name:"configRoles",params:{userId:row.user_id},query:{go:"button"}})
            },
            configStore(row) {
                this.savecookie("button", "configStore");
                this.$router.push( {name:"configStore",params:{username:row.username},query:{go:"button"}})
            },
            dialodclose(formName) {
                this.$refs[formName].resetFields();
                //this.getData();
            },
            /**--------------------------------------end--------------------------------------------------------**/
            updateBtnState(pid){
               // this.$store.dispatch("updateBtnState",pid)
                var _this=this
                 this.$store.dispatch("getButton",pid).then((res)=>{
                    var data=res.btnlist;
                   var btnAlllist=new Array("btn_0412","btn_0414","btn_0415","btn_0416","btn_0417");
                  var btnAlllist1=btnAlllist;
                  if(data.length>0) {
                      for (var i = 0; i < data.length; i++) {
                            var btnId="btn_"+data[i].resourceId;
                          for(var j=0;j<btnAlllist.length;j++){
                              if(btnAlllist[j]==btnId){
                                  btnAlllist1.splice(j,1)
                              }
                          } ;
                      }
                  }
                  //隐藏按钮
                     for(var h=0;h<btnAlllist1.length;h++){

                         if(btnAlllist1[h]=="btn_0412"){

                             _this.btnAll.btn_0412=false;
                         }
                         if(btnAlllist1[h]=="btn_0414"){

                             this.btnAll.btn_0414=false;
                         }
                         if(btnAlllist1[h]=="btn_0415"){

                             this.btnAll.btn_0415=false;
                         }
                         if(btnAlllist1[h]=="btn_0416"){

                             this.btnAll.btn_0416=false;
                         }
                         if(btnAlllist1[h]=="btn_0417"){

                             _this.btnAll.btn_0417=false;
                         }
                     }
                })
            },
            /**--------------------------------------end--------------------------------------------------------**/
        }



    }

</script>
<style>
    .el-card__header{
        border-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// UserManager.vue?54878eb8